<div>
  <span>{{ 'EMAIL_BUILDER.CONTEXT_SELECTOR.X_FOR_PREVIEW' | translate: { context: (contextName$ | async) } }}</span>
  <div class="context">
    <span class="name">{{ selectedName | async }}</span>
    @if (showWarning$ | async) {
      <mat-icon [glxyTooltip]="warningKey$ | translate">warning_filled</mat-icon>
    }
  </div>
  <button mat-raised-button (click)="openSelectDialog()">
    {{
      'EMAIL_BUILDER.CONTEXT_SELECTOR.SELECT_ANOTHER_X' | translate: { context: (contextName$ | async)?.toLowerCase() }
    }}
  </button>
</div>
